import { Button, Dialog, IconButton, MenuItem, Select } from '@mui/material';
import axios, { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useGetList, useNotify } from 'react-admin';
import { BiX } from 'react-icons/bi';
import constants from '../../constants';
import { getLocalizedErrorMessage } from '../../utils/functions';
import CreateProactiveItemCategoryDialog from './CreateProactiveItemCategoryDialog';

const BoostsTemplateDialog = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
	const categoriesList = useGetList('proactive/item/category', {
		pagination: { perPage: 999, page: 1 },
		sort: { field: 'name', order: 'ASC' },
	});
	const notify = useNotify();

	useEffect(() => {
		const fetchSetting = async () => {
			const response = await axios.get(`${constants.API_URL}/setting/boostsTemplate`);
			setTemplate(response.data?.value);
			setSettingId(response.data?._id);
		};
		fetchSetting();
	}, []);

	const [settingId, setSettingId] = useState<string | null>(null);
	const [template, setTemplate] = useState<string[]>([]);
	const [createDialogOpen, setCreateDialogOpen] = useState(false);
	return (
		<>
			<CreateProactiveItemCategoryDialog
				open={createDialogOpen}
				onClose={() => {
					setCreateDialogOpen(false);
				}}
				onCreate={async (categoryName) => {
					try {
						await axios.post(`${constants.API_URL}/proactive/item/category`, {
							name: categoryName,
						});
						categoriesList.refetch();
						notify(`הקטגוריה ${categoryName} נוצרה בהצלחה`, { type: 'success' });
					} catch (error) {
						notify(`שגיאה ביצירת קטגוריה: ${getLocalizedErrorMessage(error as AxiosError)}`, {
							type: 'error',
						});
					}
				}}
			/>
			<Dialog open={open} onClose={onClose}>
				<div className="p-4 flex flex-col gap-4">
					<h4>עדכון תבנית בוסטים שבועית</h4>
					<div dir="rtl mt-4">
						<ul className="space-y-2">
							{template.map((item, index) => (
								<li>
									<div className="flex flex-row, gap-4 items-center">
										<span className="w-4">{index + 1}</span>
										<span className="flex flex-1">
											{categoriesList.data?.find((x) => x._id === item)?.name}
										</span>
										<span>
											<IconButton
												size="small"
												onClick={() =>
													setTemplate((prev) => prev.filter((x, _index) => index !== _index))
												}
											>
												<BiX />
											</IconButton>
										</span>
									</div>
								</li>
							))}
						</ul>
					</div>
					<div>
						<Select label="קטגוריה" fullWidth>
							{categoriesList.data?.map((category) => (
								<MenuItem onClick={() => setTemplate((prev) => [...prev, category._id])}>
									{category.name}
								</MenuItem>
							))}
						</Select>

						<Button
							onClick={() => {
								setCreateDialogOpen(true);
							}}
						>
							יצירת קטגוריה חדשה
						</Button>
					</div>
					<div>
						<Button
							onClick={async () => {
								try {
									await axios.put(`${constants.API_URL}/setting/${settingId}`, { value: template });
									notify('התבנית עודכנה בהצלחה', { type: 'success' });
									onClose();
								} catch (error) {}
							}}
						>
							שמור
						</Button>
					</div>
				</div>
			</Dialog>
		</>
	);
};

export default BoostsTemplateDialog;
